import React, { Component } from 'react';
import './emergencySetDevice.less';
import { Switch } from 'antd';
import PubSub from 'pubsub-js'
import { meshLog, SPRemove, SPGet, SPSet } from "../../../../../utils/spUtils";
import { getDevicesByGroupId } from '../../../../../utils/meshUtils';
import { convertSecondsToTime } from '../../../../../utils/dataUtils';
import { sendOpcode_group_light, sendOpcode_group_onoff, sendOpcode_identify, sendOpcode_group_state, sendOpcode_devices_state } from '../../../../../utils/opcodeUtils';
import montion from "../../../../../imgs/item/montion.png";
import devices from "../../../../../imgs/item/devices.png";
import btn_refresh from "../../../../../imgs/btn/btn_refresh.png";

import wifi_4 from "../../../../../imgs/mesh/wifi_4.png";
import wifi_0 from "../../../../../imgs/mesh/wifi_0.png";
import emergency_status from "../../../../../imgs/item/emergency_status.png";
import { IsEmergencyDevice } from '../../../../../utils/pidUtils';
import { SET_ControlPageDetailPage_DIALOG_HIDE } from "../../../../../const/infoConst"


export default class EmergencySetDevice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checked: false, //group是否展开
            devices: [], //group数据

        }
    }



    componentDidMount() {
        this.updateGroupUI();
        PubSub.subscribe('updateGroupdataUI', (msg, data) => {
            this.updateGroupUI();
        })

        PubSub.unsubscribe("mqttGroupState")
        PubSub.subscribe('mqttGroupState', (msg, index) => {
            //状态更新
            this.updateGroupUI();
        })
        meshLog('更新灯的状态',);
        PubSub.unsubscribe("mqttDeviceState")
        PubSub.subscribe('mqttDeviceState', (msg, index) => {
            //状态更新
            this.updateGroupUI();
        })
    }

    updateGroupUI() {
        meshLog('group渲染第一步', this.props);
        const groupInfo = JSON.parse(SPGet("groupInfo"))
        this.setState({
            // groupDevices: groupDevices,
            devices: getDevicesByGroupId(groupInfo.groupID), //group数据
        })
    }

    //group展开
    groupArrowClick = () => {
        let mm = this.state.checked;
        this.setState({ checked: !mm });
    }


    controlPageDetailContainer = (device) => {
        SPSet('controlDevice', JSON.stringify(device))
        PubSub.publish(SET_ControlPageDetailPage_DIALOG_HIDE, device)//控制ControlPageDetailPage弹框显示
    }

    emergencyRefreshDevices = () => {
        //获取单灯的状态，通过网关来返回的
        sendOpcode_devices_state()
        meshLog('获取单灯的状态',);
    }


    vacantOk = () => {
        //关闭这个弹框，打开sensor界面
        PubSub.publish('gotoSensorset', '')//显示Sensorset界面
    }

    //显示emergencySetDeviceControl界面
    gotoEmergencySetDeviceControl = (device) => {
        SPSet('controlDevice', JSON.stringify(device))
        PubSub.publish('gotoEmergencySetDeviceControl', '')
        PubSub.publish(SET_ControlPageDetailPage_DIALOG_HIDE, device)//控制emergencySetDeviceControl弹框显示

    }

    render() {
        const { } = this.state;

        return (
            <div className="emergencySetDevice-container">
                <div className="ui_grey_bg" />
                <div className="popup">
                    <div style={{ marginTop: "20px" }}>
                        <span style={{ marginLeft: "20px", fontSize: "18px" }}>Single Device Control</span>
                        {/* <img className="refresh-icon" onClick={() => { this.emergencyRefreshDevices() }} src={btn_refresh} /> */}
                        {/* 灯数据 */}
                    </div>
                    <div className="line_space"></div>
                    <div className="emergencySetDevicetitle" >
                        <div className="title1">Device Location</div>
                        <div className="title1">Status</div>
                        <div className="title3">Operation</div>
                    </div>
                    <div style={{ height: "550px", overflow: "auto" }}>
                        {this.state.devices.map((device) => (
                            <div className="emergencySetDevicedate" key={device.macAddress} style={{ display: IsEmergencyDevice(device.pid) ? "flex" : "none" }} >
                                <div className='title1' onClick={() => { this.controlPageDetailContainer(device) }}>
                                    {device.name}
                                </div>
                                <div className='title1'>
                                    <img className='img2' src={emergency_status} />
                                    <img className='img' src={device.online == 1 ? wifi_4 : wifi_0} />

                                </div>
                                <div className='title3'>
                                    <button className='btns' onClick={() => this.gotoEmergencySetDeviceControl(device)} >Control </button>
                                </div>
                            </div>
                        ))}


                    </div>
                    {/* 底部按钮 */}
                    <div className="control-footer">
                        <button className='cancelBtn' onClick={() => this.vacantOk()}>Cancel</button>
                        <button className='okBtn' onClick={() => this.vacantOk()} >Confirm</button>
                    </div>


                </div>

            </div >
        );
    }
}
